import { FeatureRollout } from '@ms/yammer-data/dist/state/types';
import { eventPageMatchPath } from '@ms/yammer-web-support/dist/urls';
import { useRouteMatch } from 'react-router-dom';

import { useIsCurrentUserEventAdmin } from '../events';
import { useIsFeatureRolloutEnabled } from '../featureRollouts';

interface PageEventMatchParams {
  readonly broadcastId: string;
}

type UseShouldShowNewEventsLayout = () => boolean;
export const useShouldShowNewEventsLayout: UseShouldShowNewEventsLayout = () => {
  const eventsPathMatch = useRouteMatch<PageEventMatchParams>(eventPageMatchPath);
  const isAdminOrEventNotInStore = useIsCurrentUserEventAdmin(eventsPathMatch?.params?.broadcastId);
  const isModeratorOptimizedLayoutEnabled = useIsFeatureRolloutEnabled(FeatureRollout.EventsModeratorOptimizedLayout);

  if (!eventsPathMatch) {
    return false;
  }

  if (eventsPathMatch?.params?.broadcastId) {
    return !isAdminOrEventNotInStore || isModeratorOptimizedLayoutEnabled;
  }

  return false;
};
